var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._b({},'div',_vm.$attrs,false),[_vm._t("default",null,{"item":_vm.item,"itemDisabled":_vm.itemDisabled,"itemLoaded":_vm.itemLoaded,"itemLoading":_vm.itemLoading,"itemModified":_vm.itemModified,"serverItem":_vm.serverItem})],2)}
var staticRenderFns = []

export { render, staticRenderFns }